module.exports = __webpack_public_path__ + "assets/1792649897182/img/image-icon.bce41341.png";